module.exports = __webpack_public_path__ + "static/media/ConnectGroup.faf24388.jpg";